export default {
  'Custom': '자정',
  'Original': '원본',
}